import { FontSizes, FontWeights, getId, getTheme, IconButton, mergeStyleSets, Modal } from '@fluentui/react';
import React from 'react';
import { Case, getCaseOwnerUsername } from 'services';

const theme = getTheme();
const contentStyles = mergeStyleSets({
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch'
  },
  header: [
    theme.fonts.xLargePlus,
    {
      flex: '1 1 auto',
      borderTop: `4px solid ${theme.palette.themePrimary}`,
      color: theme.palette.neutralPrimary,
      display: 'flex',
      fontSize: FontSizes.xLarge,
      alignItems: 'center',
      fontWeight: FontWeights.semibold,
      padding: '12px 12px 14px 24px'
    }
  ],
  body: {
    flex: '4 4 auto',
    padding: '0 24px 24px 24px',
    overflowY: 'hidden',
    selectors: {
      p: {
        margin: '14px 0'
      },
      'p:first-child': {
        marginTop: 0
      },
      'p:last-child': {
        marginBottom: 0
      }
    }
  }
});

const iconButtonStyles = mergeStyleSets({
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: 'auto',
    marginTop: '4px',
    marginRight: '2px'
  },
  rootHovered: {
    color: theme.palette.neutralDark
  }
});

export interface ReviewModalProps {
  case: Case;
  isOpen: boolean;
  onDismiss: () => void;
}

// Review Modal: Modal for inspecting a given case
export class ReviewModal extends React.Component<ReviewModalProps, Record<string, unknown>> {
  private titleId: string = getId('title');
  private subtitleId: string = getId('subText');

  public render(): JSX.Element {
    const subjectValue = this.props.case.subject.subjectValue;
    const caseId = this.props.case.id;
    const username = getCaseOwnerUsername(this.props.case);

    // TODO: Currently modal assumes gamerpic, we should be checking current loaded config.
    return (
      <Modal
        titleAriaId={this.titleId}
        subtitleAriaId={this.subtitleId}
        isOpen={this.props.isOpen}
        onDismiss={this.props.onDismiss}
        isBlocking={false}
        containerClassName={contentStyles.container}
        dragOptions={undefined}
      >
        <div className={contentStyles.header}>
          <span id={this.titleId}>{username || caseId}</span>
          <IconButton
            styles={iconButtonStyles}
            iconProps={{ iconName: 'Cancel' }}
            ariaLabel="Close popup modal"
            onClick={this.props.onDismiss}
          />
        </div>
        <div id={this.subtitleId} className={contentStyles.body}>
          <img src={subjectValue} alt={username || caseId} />
        </div>
      </Modal>
    );
  }
}
